import React from "react";
import { Nav } from "shards-react";

import SidebarNavItem from "./SidebarNavItem";
import SidebarNavItemOpener from "./SidebarNavItemOpener";
import SidebarNavSubItem from "./SidebarNavSubItem";

import { accessCheck } from "../../../utils/tools";

const sidebarNavItems = [
  // {
  //   title: "Add New Post",
  //   htmlBefore: '<i class="material-icons">note_add</i>',
  //   to: "/add-new-post",
  // },
  {
    title: "Forms & Components",
    htmlBefore: '<i className="material-icons">view_module</i>',
    to: "/components-overview",
  },
  {
    title: "Tables",
    htmlBefore: '<i className="material-icons">table_chart</i>',
    to: "/tables",
  },
  // {
  //   title: "Errors",
  //   htmlBefore: '<i class="material-icons">error</i>',
  //   to: "/errors",
  // },
];

class SidebarNavItems extends React.Component {
  constructor(props) {
    super(props)
    const isSettingsSubPage = window.location.href.indexOf('showing-defaults') !== -1 || window.location.href.indexOf('calendar-link-settings') !== -1
    this.state = {
      navItems: sidebarNavItems,
      showSettingsSubItems: isSettingsSubPage,
      showActivitiesSubItems: false,
    };
    if (props.user.type === 'tenant') {
      this.locationName = props.locations.find(loc => loc.id=props.user.location)?.name
    }
  }

  // Helper function to check if Dispute Assistant feature is enabled for a user
  isDisputeAssistantEnabled = (user) => {
    // If no user, feature is not enabled
    if (!user) return false;
    
    // Check if we're in impersonation mode
    const isImpersonating = this.props.impersonated || false;
    
    // Get the user's client ID
    const userClient = user.client;
    const clientName = userClient && this.props.clients ? 
      this.props.clients.find(c => c.id === userClient)?.name : null;
    
    console.log('Dispute Assistant Check:', {
      user: user.name,
      userType: user.type,
      clientId: userClient,
      clientName: clientName,
      impersonating: isImpersonating,
      userFlag: user.enable_dispute_assistant
    });
    
    // Special case for Demo client - always enabled
    if (clientName === 'Demo' || userClient === 'demo') {
      console.log('Demo client detected - enabling Dispute Assistant');
      return true;
    }
    
    // Super users always have access, but only if not impersonating
    if (user.type === 'super' && !isImpersonating) return true;
    
    // For client admins and regular client users, check client feature flag
    if (user.type === 'client_admin' || user.type === 'client') {
      // Check for feature flag on the user first
      if (this.isFeatureFlagEnabled(user.enable_dispute_assistant)) {
        console.log('User has feature flag enabled');
        return true;
      }
      
      // Check if user's client has feature flag or premium tier
      if (userClient) {
        const clientData = this.props.clients && this.props.clients.find(c => c.id === userClient);
        if (clientData) {
          const hasFeatureFlag = this.isFeatureFlagEnabled(clientData.enable_dispute_assistant);
          const hasPremiumTier = (clientData.status === 'active' && clientData.tier === 'premium');
          
          console.log('Client check:', {
            clientName: clientData.name,
            hasFeatureFlag: hasFeatureFlag,
            hasPremiumTier: hasPremiumTier,
            clientFlag: clientData.enable_dispute_assistant
          });
          
          return hasFeatureFlag || hasPremiumTier;
        }
      }
    }
    
    // In development environment, enable for testing ONLY if not impersonating
    if (process.env.NODE_ENV === 'development' && !isImpersonating) {
      console.log('Development mode access granted');
      return true;
    }
    
    // Default to not enabled
    return false;
  }
  
  // Helper function to check if a feature flag is enabled (handles various formats)
  isFeatureFlagEnabled = (flag) => {
    if (flag === undefined || flag === null) return false;
    
    // Check for boolean true
    if (flag === true) return true;
    
    // Check for string 'true'
    if (typeof flag === 'string' && flag.toLowerCase() === 'true') return true;
    
    // Check for number 1
    if (flag === 1 || flag === '1') return true;
    
    // Check for string 'yes'
    if (typeof flag === 'string' && flag.toLowerCase() === 'yes') return true;
    
    // Check for string 'on'
    if (typeof flag === 'string' && flag.toLowerCase() === 'on') return true;
    
    // If it's a non-empty string that's not '0' or 'false'
    if (typeof flag === 'string' && flag !== '' && flag !== '0' && flag.toLowerCase() !== 'false') return true;
    
    // If it's a non-zero number
    if (typeof flag === 'number' && flag !== 0) return true;
    
    return false;
  }

  render() {
    const { navItems: items } = this.state;
    return (
      <div className="nav-wrapper">
        <Nav className="nav--no-borders flex-column">
          {this.props.user.type === 'tenant' && (
            <SidebarNavItem
              item={{
                title: this.locationName ?? "Permitted Vehicles",
                //htmlBefore: '<i class="material-icons">home</i>',
                to: "/tenant-vehicles",
              }}
            />
          )}
          {accessCheck(this.props.user, 'dashboard') && (
            <SidebarNavItem
              item={{
                title: "Dashboard",
                //htmlBefore: '<i class="material-icons">home</i>',
                to: "/dashboard",
              }}
            />
          )}
          {accessCheck(this.props.user, 'locations') && (
            <SidebarNavItem
              item={{
                title: "Locations",
                //htmlBefore: '<i class="material-icons">home</i>',
                to: "/locations",
              }}
            />
          )}
          {accessCheck(this.props.user, 'citations') && (
            <SidebarNavItem
              item={{
                title: "Citations",
                //htmlBefore: '<i class="material-icons">calendar_month</i>',
                to: "/citations",
              }}
            />
          )}
          {accessCheck(this.props.user, 'citations') && (
            <SidebarNavItem
              item={{
                title: "Violations",
                //htmlBefore: '<i class="material-icons">warning</i>',
                to: "/violations",
              }}
            />
          )}
          {/* {accessCheck(this.props.user, 'citations') && (
            <SidebarNavItem
              item={{
                title: "Violators",
                //htmlBefore: '<i class="material-icons">calendar_month</i>',
                to: "/violators",
              }}
            />
          )} */}
          {accessCheck(this.props.user, 'payments') && (
            <SidebarNavItem
              item={{
                title: "Payments",
                //htmlBefore: '<i class="material-icons">calendar_month</i>',
                to: "/payments",
              }}
            />
          )}
          {/* Stripe embedded dashboard — only for the roles the backend
              session callable accepts, and only when there's at least one
              verified Stripe location among those this user can see. */}
          {(this.props.user.type === 'super' || this.props.user.type === 'admin') &&
            this.props.locations?.some(loc => loc.payment_processor === 'stripe' && loc.stripe_account_status === 'active') && (
            <SidebarNavItem
              item={{
                title: "Payments dashboard",
                to: "/payments-stripe",
              }}
            />
          )}
          {accessCheck(this.props.user, 'citations') && (
            <SidebarNavItem
              item={{
                title: "Warnings",
                //htmlBefore: '<i class="material-icons">calendar_month</i>',
                to: "/warnings",
              }}
            />
          )}
          {accessCheck(this.props.user, 'users') && (
            <SidebarNavItem
              item={{
                title: "Users",
                //htmlBefore: '<i class="material-icons">calendar_month</i>',
                to: "/users",
              }}
            />
          )}
          {accessCheck(this.props.user, 'clients') && (
            <SidebarNavItem
              item={{
                title: "Clients",
                //htmlBefore: '<i class="material-icons">calendar_month</i>',
                to: "/clients",
              }}
            />
          )}
          {accessCheck(this.props.user, 'activities') && (
            <>
              <SidebarNavItemOpener
                item={{
                  title: "Activities",
                  to: "#",
                }}
                onClick={() => this.setState({ showActivitiesSubItems: !this.state.showActivitiesSubItems })}
                isOpen={this.state.showActivitiesSubItems}
              />
              <div className={`submenu-container ${this.state.showActivitiesSubItems ? 'open' : ''}`}>
                <SidebarNavSubItem
                  item={{
                    title: "All Activities",
                    to: "/activities",
                  }}
                />
                <SidebarNavSubItem
                  item={{
                    title: "Check-ins",
                    to: "/checkins",
                  }}
                />
              </div>
            </>
          )}
          {/* A.I Dispute Assistant visible to all non-tenant users */}
          {this.props.user.type !== 'tenant' && (
            <SidebarNavItem
              item={{
                title: <>Dispute Assistant <span className="beta-badge">Beta</span></>,
                //htmlBefore: '<i class="material-icons">error</i>',
                to: this.isDisputeAssistantEnabled(this.props.user) ? "/dispute-center" : "/dispute-assistant-request",
              }}
            />
          )}
        </Nav>
      </div>
    )
  }
}

export default SidebarNavItems;
